export const getFirstDayOfWeek = () => {
  try {
    const locale = new Intl.Locale(navigator.language);
    if (typeof locale.getWeekInfo === 'function') {
      const weekInfo = locale.getWeekInfo();
      return weekInfo.firstDay === 7 ? 0 : weekInfo.firstDay;
    }
  } catch (e) {
    console.warn("Intl.getWeekInfo not supported, using fallback");
  }
  const region = navigator.language.split('-')[1]?.toUpperCase();
  const sundayRegions = ['US', 'CA', 'IL', 'JP', 'PH', 'TH', 'KR'];
  
  return sundayRegions.includes(region) ? 0 : 1; 
};